// Years before the common era are stored negative (Caesar at the Rubicon is
// -49) and printed as "49 BC".
export function displayYear(year: number) {
  return year < 0 ? `${-year} BC` : String(year)
}
